import {
  BEResponseListDocumentoDTO,
  Certificato,
  FirmaRequest
} from 'client/api/backend/schemas';
import { backendApiClient } from 'client/core/network/mutators/apiClient';
import { RemoteSignType } from '../provider-parameters/ProviderParameters';

export interface IGetRemoteSignBodyDataParams {
  taskId: string | null | undefined;
  flCompletare: boolean;
  flIntermedio?: boolean;
  certificate: Certificato;
  signType: RemoteSignType;
}

export class MassiveRemoteSignLogic {
  /**
   * Ritorna i documenti associati a una attività specificata.
   */
  static async getTaskDocuments(taskId: string | null | undefined) {
    if (!taskId) return [];
    const result = await backendApiClient.request<BEResponseListDocumentoDTO>({
      url: `/attivita/${taskId}/documenti/elenco`,
      method: 'GET'
    });

    if (result.data.esito?.errore) {
      throw new Error(result.data.esito.errore.messaggioDiErrore); // prettier-ignore
    }
    return result.data.data || [];
  }

  /**
   * Ritorna una funzione che costruisce il body della richiesta per la firma remota
   * per i documenti di una attività specificata.
   */
  static async getRemoteSignBodyData(
    params: IGetRemoteSignBodyDataParams
  ): Promise<FirmaRequest[]> {
    const { taskId, flCompletare, certificate, signType } = params;

    const taskDocuments = await this.getTaskDocuments(taskId);
    return taskDocuments.map(document => ({
      firmeRequest: [
        {
          idDocumento: document.idDocumento,
          idTaskInstance: taskId!,
          flCompletare: flCompletare ?? false,
          flIntermedio: document.flIntermedio ?? false,
          idCertificato: certificate?.id,
          tipo: signType
        }
      ]
    }));
  }
}
